import { Tone } from 'generated-graphql/types';
import { createAgent, findAgentForOrg } from 'services/agents/api';

type HandleAgentUpsertProps = {
  agentName: string;
  agentTone: Tone;
  organizationId: string;
  userId: string;
};

// Agent rows are treated as immutable identities: a given (name, tone) maps to
// one Agent record per org. Resolving a new (name, tone) must reuse an existing
// matching Agent or create a new one — never mutate an existing row in place,
// which would retroactively change the name/tone read by every Campaign,
// Conversation and Message that points at it (PAD-5032).
export const handleAgentUpsert = async ({
  agentName,
  agentTone,
  organizationId,
  userId
}: HandleAgentUpsertProps) => {
  const existing = await findAgentForOrg({
    organizationId,
    name: agentName,
    tone: agentTone
  });

  if (existing) {
    return existing.id;
  }

  const agent = await createAgent({
    name: agentName,
    tone: agentTone,
    organizationId,
    userId
  });

  return agent.id;
};
